<script lang="ts">
import { IntentionI3pService } from '~/services/intentions.i3p.service'
import IntentionsI3p from '~/components/I3pComponent/intentions/IntentionsI3p.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'
import { useConfigStore } from '~/store'

export default {
    name: 'MesIntentionsArchivees',
    components: { IntentionsI3p },
    setup() {
        useHead({
            title: 'Mes intentions archivées',
            meta: [
                { name: 'description', content: 'Mes intentions archivées' },
            ],
        })
        definePageMeta({
            middleware: ['auth'],
        })
    },
    data() {
        const configStore = useConfigStore()
        const route = useRoute()
        return {
            configStore,
            route,
            baseUrl: BaseRoutesEnum.myArchivedIntentions,
            intentionI3pService: new IntentionI3pService()
                .setInitialQuery({ status: '_3_done,_4_cancelled' })
                .setHiddenFilters(['organization_id', 'status', 'current_status']),
        }
    },
    computed: {
        isApplicationServiceReady(): boolean {
            return !!this.configStore?.currentConfig?.app_info
        },
    },
    async mounted() {
        await this.intentionI3pService.loadData(!this.route.params.k)
    },
}
</script>

<template>
    <IntentionsI3p v-if="isApplicationServiceReady" :i3p-service="intentionI3pService" :base-url />
</template>
